export default function EFXStream(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="152" height="29" viewBox="0 0 152 29" fill="none" {...props}>
            <g clipPath="url(#clip0_2723_9242)">
                <path
                    d="M93.5451 11.9843C95.01 11.9843 96.5173 10.7981 96.9101 9.33051L97.7062 6.35559C98.099 4.89069 97.2286 3.70178 95.7637 3.70178H83.0254L82.2611 6.55198H94.8375L94.1475 9.13413H81.5685L79.3711 17.3954H82.147L83.5959 11.9843H87.229L91.1912 17.3954H95.2303L91.2707 11.9843H93.5451Z"
                    fill="currentColor"
                />
                <path d="M124.158 3.70178L113.367 17.3954H116.507L124.752 6.93147L127.39 17.3954H130.532L127.077 3.70178H124.158Z" fill="currentColor" />
                <path
                    d="M49.6733 9.12617L50.3633 6.54667H62.9318L63.6934 3.70178H51.0108C49.5459 3.70178 48.0386 4.89069 47.6458 6.35559L46.1411 11.9711H58.7095L58.0196 14.5532H45.4511L44.6895 17.3954H57.372C58.8369 17.3954 60.3443 16.2065 60.7371 14.7416L62.2418 9.12617H49.6733Z"
                    fill="currentColor"
                />
                <path
                    d="M148.22 17.3954L151.179 6.35559C151.572 4.89069 150.701 3.70178 149.237 3.70178H135.493L131.822 17.3954H134.672L137.592 6.46971H141.556L138.637 17.3954H141.405L144.324 6.46971H148.289L145.37 17.3954H148.22Z"
                    fill="currentColor"
                />
                <path d="M64.916 6.54667H71.2135L68.3076 17.3954H71.0808L73.9894 6.54667H80.2869L81.0485 3.70178H65.6803L64.916 6.54667Z" fill="currentColor" />
                <path d="M96.7422 17.396H112.079L112.838 14.5537H100.277L100.97 11.9716H113.53L114.294 9.12671H98.9581L96.7422 17.396Z" fill="currentColor" />
                <path d="M99.6465 6.54667H114.983L115.745 3.70178H100.411L99.6465 6.54667Z" fill="currentColor" />
                <path d="M35.707 11.9716H43.3686L44.1302 9.12671H36.4713L35.707 11.9716Z" fill="currentColor" />
                <path d="M19.608 0H11.8828L18.6315 9.1291L23.5569 5.33946L19.608 0Z" fill="currentColor" />
                <path d="M27.4825 21.1002H35.2077L29.0164 12.7247L23.6875 15.9703L27.4825 21.1002Z" fill="currentColor" />
                <path d="M42.2815 0H32.5765L15.7965 12.8736H19.4694L0.921875 28.4249L32.696 9.12645H28.9806L42.2815 0Z" fill="url(#paint0_linear_2723_9242)" />
            </g>
            <defs>
                <linearGradient id="paint0_linear_2723_9242" x1="39.9939" y1="-1.81485e-07" x2="0.982909" y2="28.3958" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#EAC64C" />
                    <stop offset="0.554786" stopColor="#C09325" />
                    <stop offset="1" stopColor="#AF7D14" />
                </linearGradient>
                <clipPath id="clip0_2723_9242">
                    <rect width="150.35" height="28.4249" fill="white" transform="translate(0.921875)" />
                </clipPath>
            </defs>
        </svg>
    );
}
